

















    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'


    import Quagga from 'quagga'; // ES6

    @Component({
        name:"weightScan",
    })
    export default class OrderScan extends AbpBase {
        resultCode: string = "";
        resultWeight: string = "";
        deliveredLoding: Boolean = false;
        createData() {
            var _this = this;
            Quagga.init({
                inputStream: {
                    name: "Live",
                    type: "LiveStream",
                    target: document.querySelector('#canvanCode'),    // Or '#yourElement' (optional)

                },
                decoder: {
                    readers: [{
                        format: "code_128_reader",
                        config: {}
                    }]
                }
            }, function (err) {
                if (err) {
                    _this.resultCode = "";
                    _this.resultWeight = "";
                    return
                }
                Quagga.start();
                Quagga.onDetected(function (data) {
                    _this.resultCode = data.codeResult.code;
                });
            });
        }
        async delivered() {
            if (!this.resultCode || this.resultCode.length != 13) {
                this.$Message.error('快递编号错误，正确快递编号为13位');
                return;
            }
            this.deliveredLoding = true;
            await this.$store.dispatch({
                type: 'backorder/commodityWeigh',
                data: { tradeNo: this.resultCode, resultWeight: this.resultWeight }
            }).finally(() => {
                this.deliveredLoding = false;
            });
            this.resultCode = '';
            this.$emit('save-success');
        }
        stop() {
            Quagga.stop();
        }
        HideMenu() {
            var _this = this;
            var menu: any = document.querySelector("div[class='sidebar-menu-con']");
            var head: any = document.querySelector("div[class='main-header-con']");
            var page: any = document.querySelector("div[class='single-page-con']");
            if (menu && head && page) {
                head.style.display = "none";
                menu.style.display = "none";
                page.style.top = "0px";
                page.style.left = "0px";
            } else {
                setTimeout(function () { _this.HideMenu(); }, 200);
            }
        }
        created() {
            if (abp.isMobile()) {
                this.HideMenu();
            }
        }
    };
